module.exports = __webpack_public_path__ + "static/img/school-12.aa44f81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-12.png
// module id = 4Xyv
// module chunks = 1